<div class="notification-area form">

  @if (data.isWmAdmin) {
    <div class="form-item">
      <div class="form-label">Scope</div>
      <p-select [options]="availableScopes" [(ngModel)]="selectedScope" data-testing-id="editor-scope-edit"></p-select>
    </div>
  }
  @if (selectedScope === 'Customer Scope') {
    <div class="form-item">
      <div class="form-label">Search Customer</div>
      <p-autoComplete class="drop-down-search-box" [(ngModel)]="selectedCustomer" [suggestions]="customerList" (completeMethod)="searchCustomer($event)" field="name" data-testing-id="editor-customer-search"></p-autoComplete>
    </div>
  }
  @if (availableTopics.length > 1) {
    <div class="form-item">
      <div class="form-label">Topic</div>
      <p-select [options]="availableTopics" [(ngModel)]="topic" data-testing-id="editor-topic-edit"></p-select>
    </div>
  }
  <div class="form-item">
    <div class="form-label">Title</div>
    <input class="form-item-content" pInputText size="40" [ngModel]="title" (ngModelChange)="writeTitle($event)" [required]="true" data-testing-id="editor-title-input">
  </div>
  <div class="form-item">
    <div class="form-label">Message</div>
    <p-editor class="form-item-content p-d-block" [ngModel]="text" (onTextChange)="writeText($event)" [required]="true" [style]="{'height':'320px', 'width': '100%'}" [bounds]="'.wm-modaltoolcontainer-view'" data-testing-id="editor-content-edit">
      <p-header>
        <span class="ql-formats">
          <button type="button" class="ql-bold" aria-label="Bold"></button>
          <button type="button" class="ql-underline" aria-label="Underline"></button>
        </span>
        <span class="ql-formats">
          <button type="button" class="ql-link" aria-label="Link"></button>
        </span>
        <span class="ql-formats">
          <button class="ql-list" value="ordered"></button>
          <button class="ql-list" value="bullet"></button>
          <button class="ql-indent" value="-1"></button>
          <button class="ql-indent" value="+1"></button>
        </span>
      </p-header>
    </p-editor>
  </div>
  <div class="preview-toggle">
    <span (click)="togglePreview()" data-testing-id="editor-preview-btn">
      @if (!previewShown) {
        <fa-icon icon="caret-right"></fa-icon>
      }
      @if (previewShown) {
        <fa-icon icon="caret-down"></fa-icon>
      }
      @if (!previewShown) {
        <span> Show Preview</span>
      }
      @if (previewShown) {
        <span> Hide Preview</span>
      }
      <div class="preview-container">
        @if (previewShown) {
          <wm-display-notification [notification]="previewNotification" [seenDate]="seenDate"></wm-display-notification>
        }
      </div>
    </span>
  </div>
  @if (data.isWmAdmin) {
    <p class="warning">
      Global Notification - ATTENTION: THIS SENDS THE NOTIFICATION TO ALL WEBMATE USERS ACROSS ALL CUSTOMERS!
    </p>
  }
  @if (!sending) {
    <button pButton label="Send Notification"  [disabled]="false" (click)="submit()" data-testing-id="editor-submit-btn">
      <fa-icon [icon]="faCommentLines" [fixedWidth]="true"></fa-icon>
    </button>
  }
  @if (sending) {
    <button pButton label="Send Notification"  (click)="submit()" data-testing-id="editor-submit-btn">
      <fa-icon icon="sync-alt" animation="spin" [fixedWidth]="true"></fa-icon>
    </button>
  }
</div>
